import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { Menu, Transition } from '@headlessui/react';
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/solid';
import { classNames } from '@/helpers/classes';
import useQueryParams from '@/hooks/useQueryParams';

const SORT_OPTIONS = ['name-asc', 'name-desc', 'price-asc', 'price-desc'];

const Sort = () => {
  const { t } = useTranslation();
  const [query, setQuery] = useQueryParams();

  const { sort = '' } = query;

  return (
    <Menu as="div" className="relative">
      {({ open }) => (
        <>
          <Menu.Button className="group flex items-center space-x-3 text-sm font-bold tracking-wide uppercase text-black">
            <span>{t('SORT')}</span>

            {open ? (
              <ChevronUpIcon className="h-5 w-5" />
            ) : (
              <ChevronDownIcon className="h-5 w-5" />
            )}
          </Menu.Button>

          <Transition
            as={Fragment}
            enter="transition ease-out duration-100"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-75"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
          >
            <Menu.Items
              className="origin-top-right absolute -right-32 sm:right-0 mt-2 w-48 rounded-md shadow-2xl bg-white ring-1 ring-black ring-opacity-5 focus:outline-none"
              style={{ zIndex: 10 }}
            >
              <div className="py-1">
                {SORT_OPTIONS.map((option, i) => (
                  <Menu.Item key={i}>
                    {({ active }) => (
                      <button
                        onClick={() => setQuery({ sort: option })}
                        className={classNames(
                          sort === option
                            ? 'font-medium text-black'
                            : 'text-gray-600',
                          active ? 'bg-gray-100' : '',
                          'block px-4 py-2 text-sm text-left w-full'
                        )}
                      >
                        {t(`SORT_OPTIONS.${option}`)}
                      </button>
                    )}
                  </Menu.Item>
                ))}
              </div>
            </Menu.Items>
          </Transition>
        </>
      )}
    </Menu>
  );
};

export default Sort;
